import { render, staticRenderFns } from "./success.vue?vue&type=template&id=0ccc90ac&"
import script from "./success.vue?vue&type=script&lang=js&"
export * from "./success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\DevOpsAgent\\agent1\\_work\\10\\s\\Site\\Source\\Web\\Marketing.UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ccc90ac')) {
      api.createRecord('0ccc90ac', component.options)
    } else {
      api.reload('0ccc90ac', component.options)
    }
    module.hot.accept("./success.vue?vue&type=template&id=0ccc90ac&", function () {
      api.rerender('0ccc90ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Views/Marketing/ProForm/components/templates/success.vue"
export default component.exports